module.exports = __webpack_public_path__ + "static/img/04-08.8971bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-08.png
// module id = F5D9
// module chunks = 0